module.exports = __webpack_public_path__ + "static/media/townhouse_blue.5467b0ae.svg";